if (!customElements.get('bed-bundle')) {
  class BedBundle extends HTMLElement {
    bedBundleObject;
    currentBundleItem;
    bedBundleSettings;
    initBigsizeItems;
    initBigsizeItemsList;
    MAX_BUNDLE_ITEMS = 6;
    ESSENTIAL_BUNDLE_ITEMS = 3;
    MAX_IMAGES_PER_LAYOUT = 3;
    NUMBER_VIEW_PER_OPTIONS = 2;
    image_config;
    selected_option_view = false;
    mapBackgroundImage = {
      'adult-1': 'aldultBackgrounds',
      'adult-2': 'aldult2Backgrounds',
      kid: 'childBackgrounds',
    };
    mapBackgroundSize = {
      'adult-1': '3d_image_view_angle',
      'adult-2': '3d_image_2_view_angle',
      kid: '3d_child_image_view_angle',
    };
    bundleIndex = {
      'quilt-cover': 0,
      pillowcases: 1,
      sheet: 2,
      extras: 3,
    };
    bundleName = {
      'quilt-cover': 'Quilt',
    };
    EXTRA_BUNDLE_ITEMS = this.MAX_BUNDLE_ITEMS - this.ESSENTIAL_BUNDLE_ITEMS;
    steps = ['bed-options', 'quilt', 'pillowcases', 'sheets', 'extra'];
    constructor() {
      super();
      this.bedBundleObject = {...window.bedBundleObject};
      this.bedBundleSettings = {...window.bedBundleSettings};
      this.currentBundleItem = {
        currentBundleItemId: Object.entries(window.bedBundleObject)[0][0],
        currentBundleItemName: Object.entries(window.bedBundleObject)[0][1].bundleItemName,
        currentExtrasItemIndex: undefined,
      };
      this.initialBundle = Object.assign({}, window.bedBundleObject);
      this.initBigsizeItems = document.querySelectorAll('.bed-bundle-item__big-size');
      this.initBigsizeItemsList = document.querySelector('.bed-bundle-big-size-list');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.initCount = 0;
      this.init = this.init.bind(this);
      this.init();
    }

    init() {
      const ELM_gpoApp = this.querySelector('.gpo-app');
      if (this.initCount > 40) {
        return;
      }
      if (!ELM_gpoApp) {
        this.initCount++;
        return setTimeout(this.init, 500);
      }
      const productWidth = this.calculaWidth();
      if (productWidth.width + 500 < window.innerWidth) {
        document.querySelector('.Product.Product--bed-bundle').style.width =
          productWidth.width + 500 + 'px';
      }
      let productSection = document.querySelector('section[data-section-type="product"]');
      if (productSection) {
        productSection = productSection.parentElement.nextElementSibling;
        while (productSection) {
          productSection.style.display = 'block';
          productSection = productSection.nextElementSibling;
        }
      }
      document.querySelector('.loading-page').style.display = 'none';
      //calc height of left section
      if (this && window.innerWidth > 750) {
        const height = document.querySelector(
          '.bundle-heading-group--subheadding-wrapper'
        )?.clientHeight;
        document.querySelector('.Product__InfoWrapper').style.display = 'block';
      }

      //render Options
      this.initOptions();

      //onClick big-size items
      this.querySelectorAll('.bed-bundle-item__big-size').forEach(
        (item = new HTMLElement(), index = 0) => {
          item.addEventListener('click', (e) => {
            e.stopPropagation();
            this.selectBigAndMiniItem(index, true);
          });
        }
      );
      if (!document.querySelector('form.ProductForm [data-field-name="custom-bed"]')) {
        const _nodeCustom = document.createElement('DIV');
        _nodeCustom.setAttribute('data-field-name', 'custom-bed');
        document.querySelector('form.ProductForm').appendChild(_nodeCustom);
      }
      this.querySelector('.bed-bundle-mini-icon-custom').addEventListener('click', (e) => {
        e.stopPropagation();
        let iconEl = e.target;
        while (!iconEl.classList?.contains('bed-bundle-mini-icon-custom')) {
          iconEl = iconEl.parentElement;
        }
        const checkMarkEl = iconEl.nextElementSibling.querySelector(
          '.bed-bundle-mini-icon__checkmark'
        );
        if (checkMarkEl && checkMarkEl.style.display == 'block') {
          return;
        }
        document.querySelector('.bed-bundle-mini-icon-custom').classList.add('active');
        document.querySelectorAll('.bed-bundle-mini-icon img').forEach((x) => {
          try {
            x.src = JSON.parse(x.getAttribute('data-src')).original_src;
          } catch (error) {
            //
          }
        });
        document.querySelector('.bed-options-custom > div').style.display = 'block';
        document.querySelector('.next-step-pre-title').innerHTML = 'ADD QUILT TO BUNDLE';
        document.querySelector('.next-step-title').innerHTML = '';
      });
      //onClick mini-size items
      this.querySelectorAll('.bed-bundle-mini-icon').forEach(
        (item = new HTMLElement(), index = 0) => {
          item.addEventListener('click', (e) => {
            e.stopPropagation();
            let iconEl = e.target;
            while (!iconEl.classList?.contains('bed-bundle-mini-icon')) {
              iconEl = iconEl.parentElement;
            }
            const checkMarkEl = iconEl.previousElementSibling.querySelector(
              '.bed-bundle-mini-icon__checkmark'
            );
            if (checkMarkEl && checkMarkEl.style.display != 'block') {
              return;
            }
            this.selectBigAndMiniItem(index, true);
          });
        }
      );

      this.querySelectorAll(`.bed-bundle-options.extras .gpo-swatches.buttons`).forEach((item) => {
        item.addEventListener('change', () => {
          if (item.querySelector('input')?.getAttribute('previous-value') === 'checked') {
            let {value} = item.querySelector('input');
            value = value.split('--')[0];
            this.onDisplayOptions(value);
          }
        });
      });

      document.addEventListener('change', (e) => {
        if (e.target.matches('.bed-room-styled input')) {
        } else if (
          e.target.matches(
            `.bed-bundle-options.bed-bundle-options__fabric-color .gpo-swatches.image-swatches input`
          )
        ) {
          if (e.target.checked) {
            const item = e.target;
            this.chooseColorOptions(item);
            this.updateChoose({color: item.id, colorElement: parent && parent.id});
          }
        } else if (e.target.matches(`.bed-bundle-options.size .gpo-swatches.buttons input`)) {
          if (e.target.checked) {
            const item = e.target;
            this.updateChoose({
              size: item.id,
            });
          }
        } else if (e.target.matches(`.bed-bundle-options.sheet-type .gpo-swatches.buttons input`)) {
          if (e.target.checked) {
            const item = e.target;
            this.updateChoose({
              type: item.id,
            });
          }
        } else if (
          e.target.matches(`.bed-bundle-options.extras-bundle-item .gpo-swatches.buttons input`)
        ) {
          if (e.target.checked) {
            const item = e.target;
            this.updateChoose({
              extra: item.id,
              value: item.value,
            });
          }
        }
      });

      //onClick change or remove item
      this.querySelectorAll('.select-bundle-item-title').forEach((item, index) => {
        item.addEventListener('click', (e) => {
          e.stopPropagation();
          if (index >= this.ESSENTIAL_BUNDLE_ITEMS) {
            this.deleteData(index);
            this.resetSelectedProduct(index);
            this.setDisplayButtonNextStepNameAfterDeleteData();
            this.renderSlide();
          } else {
            this.selectBigAndMiniItem(index);
          }
        });
      });

      //onClick next-step
      this.querySelector('.next-step__wrapper').addEventListener('click', (e) => {
        this.jumpToNextBundleItem();
      });

      //onClick start again
      this.querySelector('.start-again__wrapper').addEventListener('click', () => {
        window.scrollTo({top: 0, behavior: 'smooth'});
        window.location.reload();
      });

      this.checkDisabledViewBundleSummary();

      //onClick view bundle summary popup
      this.querySelector('.view-bundle-summary__wrapper').addEventListener('click', (e) => {
        e.stopPropagation();
        this.renderBundleSummary.bind(this)();
        this.querySelectorAll('.list-necessities .bundle-summary-item').forEach((item, index) => {
          item
            .querySelector('.bundle-summary-item__info-action .edit')
            .addEventListener('click', () => {
              this.editAnItemInBundleSummary(index);
            });
        });
        this.querySelectorAll('.list-extras .bundle-summary-item').forEach((item, index) => {
          item
            .querySelector('.bundle-summary-item__info-action .edit')
            .addEventListener('click', () => {
              this.editAnItemInBundleSummary(index + 3);
            });
        });
      });

      this.querySelector('.bundle-summary__add-bundle-to-cart-wrapper').addEventListener(
        'click',
        () => {
          if (!this.checkBundleIsNull()) {
            this.addBundleToCart();
          }
        }
      );

      this.querySelector('.bundle-summary__button').addEventListener('click', () => {
        const currentDisplayedBundleItems = this.checkCurrentDisplayedBundleItems();

        let bundleItemId;
        Object.entries(this.bedBundleObject).forEach(([k, v]) => {
          if (v.bundleItemName === 'extras') {
            bundleItemId = k;
            return;
          }
        });

        const list = this.bedBundleObject[bundleItemId].list;
        let indexAtEmptyObj = list.findIndex((item) => item.id === undefined);
        let index;
        if (indexAtEmptyObj > -1) {
          index = indexAtEmptyObj + 3;
          this.setCurrentBundleStep(this.querySelectorAll('.bed-bundle-item__big-size')[index]);
          this.querySelectorAll('.bed-bundle-item__big-size')[index].classList.remove('d-none');
        }

        if (index > currentDisplayedBundleItems) return;
        else this.selectBigAndMiniItem(index);

        if (window.innerWidth <= 750) {
          window.scrollTo({top: 0, behavior: 'smooth'});
        }
      });

      let outerItem;
      const higherLevelModal = document.getElementById('alert-bundle-modal');
      document.addEventListener('click', (e) => {
        if (e.target.matches('.bundle-summary-item__info-action .remove')) {
          const higherLevelModal = document.getElementById('alert-bundle-modal');
          const item = e.target;
          higherLevelModal.classList.add('d-block');
          outerItem = item.closest('.bundle-summary-item').dataset;
        }

        if (e.target.matches('.bundle-summary-item__info-action .edit')) {
          higherLevelModal.classList.remove('d-block');
        }
        if (
          e.target.matches('.gpo-swatch__image') &&
          e.target.parentElement.parentElement.tagName == 'LABEL'
        ) {
          if (e.target.parentElement.parentElement.previousElementSibling.checked) {
            this.removeChoose('color');
            const newIndex = this.bundleIndex[this.currentBundleItem.currentBundleItemName];
            if (this.currentBundleItem.currentBundleItemName == 'extras') {
              if (
                this.bedBundleObject[this.currentBundleItem.currentBundleItemId].list.filter(
                  (x) => x.id != undefined
                ).length == 0
              ) {
                this.removeCheckmarkDone('.bed-bundle-mini-icon', newIndex);
              }
            } else {
              this.removeCheckmarkDone('.bed-bundle-mini-icon', newIndex);
            }
          }
        }
      });

      this.querySelector('.alert-button__remove-btn-wrapper').addEventListener('click', (e) => {
        let {bundleItemName, index} = outerItem;
        higherLevelModal.classList.remove('d-block');
        index = parseInt(index) + 3;
        if (bundleItemName === 'extras' && index >= this.ESSENTIAL_BUNDLE_ITEMS) {
          this.deleteData(index);
          this.resetSelectedProduct(index);
          this.setDisplayButtonNextStepNameAfterDeleteData();
          this.renderSlide();
        }
        this.renderBundleSummary();
      });
      if (document.querySelector('[data-json]')) {
        this.image_config = JSON.parse(
          document.querySelector('[data-json]').attributes.getNamedItem('data-json').value
        );
        this.aldultBackgrounds = JSON.parse(
          document.querySelector('[data-images-json]').attributes.getNamedItem('data-images-json')
            .value
        );
        this.aldult2Backgrounds = JSON.parse(
          document
            .querySelector('[data-images-2-json]')
            .attributes.getNamedItem('data-images-2-json').value
        );
        this.childBackgrounds = JSON.parse(
          document
            .querySelector('[data-child-images-json]')
            .attributes.getNamedItem('data-child-images-json').value
        );
        this.image_config_order = this.image_config.image_layer_order;
        this.selected_option_view = 'adult-1';
        this.MAX_IMAGES_PER_LAYOUT =
          this.image_config[this.mapBackgroundSize[this.selected_option_view]];
        this.backgrounds = this[this.mapBackgroundImage[this.selected_option_view]];
        this.baseLayouts = Math.floor(this.backgrounds.length / this.MAX_IMAGES_PER_LAYOUT);
        this.currentBaseLayout = 0;
        this.renderSlide();
      } else {
        console.log('missing configuration for template');
      }
      if (window.ResizeObserver) {
        this.slideResizeObject = new ResizeObserver((e) => {
          if (!this.minWidth) {
            this.minWidth = e[0].contentRect.width;
          }
          if (this.minWidth != e[0].contentRect.width) {
            delete this.originRect;
            this.renderSlide('renderResize');
            this.minWidth = e[0].contentRect.width;
            document.querySelector('.Product.Product--bed-bundle').style.width = 'initial';
            const productWidth = this.calculaWidth();
            if (productWidth.width + 500 < window.innerWidth) {
              document.querySelector('.Product.Product--bed-bundle').style.width =
                productWidth.width + 500 + 'px';
            }
          }
        });
        this.slideResizeObject.observe(document.querySelector('body'));
      }
      document.addEventListener('DOMContentLoaded', function () {
        let el = document.getElementsByTagName('img');
        Object.values(el).forEach(function (el) {
          var img = new Image();
          img.onload = function () {
            el.style.opacity = 1;
          };
          img.src = el.src;
        });
      });

      document.querySelector('.bed-bundle-mini-icon').classList.add('enable');
      this.renderRoomStyle();
      this.renderOptionSize();
      this.selectBigAndMiniItem(0, true);
    }
    calculaWidth() {
      const IMG_WIDTH = 1426;
      const IMG_HEIGHT = 1189;
      const top = document.querySelector('#section-header').clientHeight;
      const maxHeight = window.innerHeight - top - 20;
      let clientWidth = document.querySelector('.Product__Wrapper').clientWidth;
      let match = window.matchMedia('screen and (max-width: 480px)');
      let width = document.querySelector('.Product__Wrapper').clientWidth;
      let height = (width * IMG_HEIGHT) / IMG_WIDTH;
      if (height > maxHeight) {
        height = maxHeight;
        width = (height * IMG_WIDTH) / IMG_HEIGHT;
        if (width > clientWidth) {
          width = clientWidth;
          height = (width * IMG_HEIGHT) / IMG_WIDTH;
        }
      }

      if (!match.matches) {
        match = window.matchMedia('screen and (max-width: 1008px)');
        if (match.matches) {
          width = 500;
          height = (width * IMG_HEIGHT) / IMG_WIDTH;
        }
      }
      return {width, height};
    }
    renderRoomStyle() {
      document.querySelector('#room-style-container').innerHTML = `
        <div class="bed-options-custom gpo-app room-style">
          <div class="gpo-selected-values"></div>
          <div class="gpo-element gpo-form__group bed-bundle-options custom-bed gpo-col-12 rounded__style" style="display:flex">
            <label for="buttons-2" class="gpo-label">
              <span class="label-content">ROOM STYLE</span>
            </label>
            <div class="room-style">
              <div class="gpo-swatches buttons">
                <input type="radio" id="aldult-1" checked="true" name="bed-size-custom-option" data-field-name="custom-bed" data-type="buttons" value="adult--Adult 1">
                <label for="aldult-1" data-option="adult-1">
                  <span>Adult</span>
                  <div class="gpo-tooltip">
                    <div class="gpo-tooltip__title">
                      <span>Aldult</span>
                    </div>
                  </div>
                </label>
              </div>
              <div class="gpo-swatches buttons">
                <input type="radio" id="children-1" name="bed-size-custom-option" data-field-name="custom-bed" data-type="buttons" value="kid--Kid">
                <label for="children-1" data-option="kid">
                  <span>Kid</span>
                  <div class="gpo-tooltip">
                    <div class="gpo-tooltip__title">
                      <span>Kid</span>
                    </div>
                  </div>
                </label>
              </div>
              <div class="gpo-swatches buttons" style="display:none">
                <input type="radio" id="adult-2" name="bed-size-custom-option" data-field-name="custom-bed" data-type="buttons" value="aldult-2--Aldult 2">
                <label for="adult-2" data-option="adult-2">
                  <span>Adult 2</span>
                  <div class="gpo-tooltip">
                    <div class="gpo-tooltip__title">
                      <span>Adult 2</span>
                    </div>
                  </div>
                </label>
              </div>
            </div>
          </div>
          <div class="gpo-form__group"></div>
        </div>
      `;
    }
    renderOptionSize() {
      this.childSize = [];
      this.aldultSize = [];
      const matchSize = (input) => {
        if (input.value.indexOf('single') > -1) {
          this.childSize.push(input.parentElement);
        } else {
          this.aldultSize.push(input.parentElement);
        }
      };
      document.querySelector('.next-step-pre-title').innerHTML = 'ADD QUILT TO BUNDLE';
      document.querySelector('.next-step-title').innerHTML = '';
      document
        .querySelectorAll('input[name=quilt-cover-size-variants-selection]')
        .forEach(matchSize);
      document
        .querySelectorAll('input[name=pillowcase-size-variants-selection]')
        .forEach(matchSize);
      document.querySelectorAll('input[name=sheet-size-variants-selection]').forEach(matchSize);
      document.querySelectorAll('input[name=euro-size-variants-selection]').forEach(matchSize);
      document
        .querySelectorAll('input[name=silk-pillowcase-size-variants-selection]')
        .forEach(matchSize);
      document.querySelectorAll('input[name=valance-size-variants-selection]').forEach(matchSize);
      document.querySelector('.bed-bundle-mini-icon').classList.add('enable');
      const mapRoomStyled = {
        'adult-1': 'Adult',
        kid: 'Kid',
      };
      const inputRoomSelected = document.querySelector(
        'input[data-field-name=buttons-bed-room-style-size]'
      );
      const activeOptionBySize = (optionView) => {
        const styledInputEL = document.querySelector(
          `.bed-room-styled input[value=${mapRoomStyled[optionView]}]`
        );
        if (styledInputEL) {
          styledInputEL.click();
        }
        document.querySelector('buttons-bed-room-style-size');
        document.querySelector('.next-step__wrapper').classList.add('active');
        document.querySelector(
          '.bed-bundle-mini-icon-custom .bed-bundle-mini-icon__checkmark'
        ).style.display = 'block';
        document
          .querySelector('.bed-bundle-mini-icon-custom + .bed-bundle-mini-icon')
          .classList.add('enable');
        if (document.querySelector('.slide-content')) {
          document.querySelector('.slide-content').style.left = 0;
        }
        this.currentBaseLayout = 0;
        this.selected_option_view = optionView;
        this.MAX_IMAGES_PER_LAYOUT =
          this.image_config[this.mapBackgroundSize[this.selected_option_view]];
        this.backgrounds = this[this.mapBackgroundImage[this.selected_option_view]];
        this.selectBigAndMiniItem(0);
        this.bedBundleObject = Object.assign(
          {},
          Object.keys(this.initialBundle).reduce((result, item, index) => {
            result[item] = Object.keys(this.initialBundle[item]).reduce((_result, _item) => {
              if (['bundleItemName', 'discount', 'list'].indexOf(_item) == -1) {
                delete _result[_item];
              }
              if ('list' === _item) {
                _result['list'] = [{}, {}, {}];
              }
              return _result;
            }, this.initialBundle[item]);
            return result;
          }, {})
        );
        document
          .querySelectorAll(`.bed-bundle-mini-icon:nth-child(n + 3)`)
          .forEach((x) => x.classList.remove('enable'));
        document.querySelectorAll('input[previous-value="checked"]').forEach((x) => {
          let input = document.querySelector(`input[data-field-name="${x.getAttribute('name')}"]`);
          if (input) {
            input.value = null;
            input.removeAttribute('name');
          }
          x.setAttribute('previous-value', 'false');
        });
        this.currentBundleItem = {
          currentBundleItemId: Object.entries(window.bedBundleObject)[0][0],
          currentBundleItemName: Object.entries(window.bedBundleObject)[0][1].bundleItemName,
          currentExtrasItemIndex: undefined,
        };
        this.resetSelectedProduct(3);
        this.resetSelectedProduct(2);
        this.resetSelectedProduct(1);
        this.resetSelectedProduct(0);
        document.querySelector('.bed-bundle-mini-icon').classList.add('enable');
        this.setDisplayButtonNextStepNameAfterDeleteData();
        this.renderSlide();
      };
      document.querySelectorAll('.bed-options-custom .gpo-swatches.buttons').forEach((item) =>
        item.addEventListener('click', (e) => {
          activeOptionBySize(item.querySelector('label').getAttribute('data-option'));
        })
      );
      document.querySelectorAll('.bed-bundle-options[style*="block"]').forEach((x) => {
        if (!x.classList.contains('custom-bed')) {
          x.style.display = 'none';
        }
      });
    }
    renderSlide(from) {
      if (this.backgrounds) {
        const {width, height} = this.calculaWidth();
        document.querySelector('.Product--bed-bundle').style.minHeight = height + 'px';
        this.sideWrapperEl = document.querySelector('.fixed-slide-wrapper');
        if (!this.sideWrapperEl) {
          this.sideWrapperEl = document.createElement('DIV');
          this.sideWrapperEl.classList.add('fixed-slide-wrapper');
          this.sideWrapperEl.style.width = width + 'px';
          document.querySelector('.Product__Wrapper').prepend(this.sideWrapperEl);
        }
        this.backgroundsHTML = document.createElement('DIV');
        this.backgroundsHTML.classList.add('slide-wrapper');
        const mapping_order = {
          'fitted-sheets': 2,
          'quilt-covers': 3,
          pillowcases: 4,
          pillowcase: 4,
          'flat-sheets': 5,
          euro: 6,
          silk: 7,
          valances: 1,
          ...(this.image_config_order || {}),
        };
        const mapping_extra_order = {
          'fitted-sheets': 8,
          'quilt-covers': 9,
          pillowcases: 10,
          pillowcase: 10,
          'flat-sheets': 11,
          euro: 12,
          silk: 13,
          valances: 14,
          ...((this.image_config_order || {})['extra'] || {}),
        };
        const getMappingOrder = (productType, tags, isExtra) => {
          if (!tags) return 0;
          let order = isExtra ? mapping_extra_order : mapping_order;
          if (order.hasOwnProperty(productType)) {
            return order[productType];
          }
          return Object.keys(order)
            .map((key) => {
              if (tags.indexOf(key) > -1) {
                return order[key] || 0;
              }
              return 0;
            })
            .filter((x) => !!x)[0];
        };
        let extraItems = [];
        let items = Object.values(this.bedBundleObject).reduce((result, item) => {
          if (item.hasOwnProperty('list')) {
            item.list.forEach((x) => {
              x.orderNumber = getMappingOrder(x.productType, x.tags, true);
              x.isExtra = true;
            });
            result.push(...item.list);
            extraItems.push(...item.list);
          } else {
            item.orderNumber = getMappingOrder(item.productType, item.tags);
            result.push(item);
          }
          return result;
        }, []);
        items.forEach((item, index) => {
          let count = -1;
          for (let i = 0; i < index; i++) {
            if (items[i]?.productType == item?.productType) {
              count += 1;
            }
          }
          item.extraIndex = count;
        });
        items = items.sort(
          (x, y) =>
            getMappingOrder(x.productType, x.tags, x.isExtra && x.extraIndex > -1) -
            getMappingOrder(y.productType, y.tags, y.isExtra && y.extraIndex > -1)
        );
        let item3DImagesSource = items.map((x) => {
          if (x.isExtra && x.extraIndex > -1) {
            let currentIndex = x.extraIndex;
            let images = (x.images && x.images[this.selected_option_view + '-extra']) || [];
            let displayImages = images.slice(
              x.extraIndex * this.MAX_IMAGES_PER_LAYOUT,
              x.extraIndex * this.MAX_IMAGES_PER_LAYOUT + this.MAX_IMAGES_PER_LAYOUT
            );
            while (images.length && !displayImages.length && currentIndex > 0) {
              currentIndex -= 1;
              displayImages = images.slice(
                currentIndex * this.MAX_IMAGES_PER_LAYOUT,
                currentIndex * this.MAX_IMAGES_PER_LAYOUT + this.MAX_IMAGES_PER_LAYOUT
              );
            }
            return displayImages;
          }
          return x.images && x.images[this.selected_option_view];
        });
        let find3DImagesByIndex = (index) => {
          return item3DImagesSource.map((array) => {
            return array && array[index];
          });
        };
        let itemImages = extraItems.filter((x) => x.id);
        const maxItems = itemImages.length + this.backgrounds.length - 1;
        let left = parseInt(document.querySelector('.slide-content')?.style?.left || 0);
        if (left % Math.round(width) != 0 || -left / Math.round(width) > maxItems) {
          left = 0;
        }
        const buildContents = (width, height, size) => {
          return [
            this.backgrounds
              .map((imageUrl, index) => {
                const activedClass =
                  this.currentBaseLayout == Math.floor(index / this.MAX_IMAGES_PER_LAYOUT);
                if (!activedClass) {
                  return null;
                }
                return `<div class="bed-bg" data-actived="${activedClass}" data-base-number="${Math.floor(index / this.MAX_IMAGES_PER_LAYOUT)}" data-index="${Math.floor(index % this.MAX_IMAGES_PER_LAYOUT)}" style="background-image: url('${imageUrl}');width:${width}px; height:${height}px;">
              ${find3DImagesByIndex(Math.floor(index % this.MAX_IMAGES_PER_LAYOUT))
                .map((img) => {
                  return img
                    ? `<div class="bed-bg-item" style="background-image: url('${img}');width:${width}px; height:${height}px;">
                  <img src="${img}" style="width:100%; height: 100%; display:none;" />
                 </div>`
                    : '';
                })
                .filter((x) => !!x)
                .join('')}
            </div>`;
              })
              .filter((x) => !!x)
              .join(''),
          ].join('');
        };
        const buildExtraContents = (width, height, size) => {
          return itemImages
            .map((item, index) => {
              const imageUrl = item.featuredImage;
              return `<div class="bed-bg" data-index="${3 + index}" style="background-image: url('${imageUrl}');width:${width}px; height:${height}px;background-size: contain;">
                <button data-index="${3 + index}" class="removeItem">X</button>
              </div>`;
            })
            .join('');
        };
        const buildBaseLayoutAnchor = () => {
          return new Array(this.baseLayouts)
            .fill(this.MAX_IMAGES_PER_LAYOUT)
            .map((i, index) => {
              const activedClass = this.currentBaseLayout == index ? 'actived' : '';
              return `<div class="btn-item ${activedClass}" data-base-index="${index}" style="background-image: url('${this.backgrounds[i * index]}}'); width:64px; height:64px;background-size: cover;">
            </div>`;
            })
            .join('');
        };
        this.backgroundsHTML.innerHTML = `
          <div class="slide-content" style="display: flex;left: ${left}px;position: relative;right: 0;">
            ${buildContents(width, height)}
          </div>
          <div class="slide-content-mini" style="display:none">
            ${buildExtraContents(height / 11, height / 11)}
          </div>
          <div class="slide-control" style="display: ${this.MAX_IMAGES_PER_LAYOUT > 1 ? 'flex;' : 'none;'}">
            <div class="btn-control" data-previous><svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 40px;height: 40px;"><rect y="0.359375" width="25.8141" height="25.8141" rx="12.907" fill="white"></rect><path d="M18.4062 13.2656H7.40625" stroke="#241F21" stroke-width="0.613379" stroke-linecap="round" stroke-linejoin="round"></path><path d="M11.9062 8.76562L7.40625 13.2656L11.9062 17.7656" stroke="#241F21" stroke-width="0.613379" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>
            <div class="btn-control" data-next><svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 40px;height: 40px;"><rect x="0.1875" y="0.359375" width="25.814" height="25.814" rx="12.907" fill="white"></rect><path d="M7.59375 13.2656H18.5938" stroke="#241F21" stroke-width="0.613372" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14.0938 8.76562L18.5938 13.2656L14.0938 17.7656" stroke="#241F21" stroke-width="0.613372" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>
          </div>
          <div class="slide-layout-control" style="display:none">
            ${buildBaseLayoutAnchor()}
          </div>
          <div class="slide-loading slide-ring"></div>
        `;
      }
      const slide = document.querySelector('.fixed-slide-wrapper slide-wrapper');
      if (slide) {
        slide.remove();
      }
      this.sideWrapperEl.replaceChildren(this.backgroundsHTML);

      const allImages = document.querySelectorAll('.slide-content img');
      let loaded = 0;
      const checkImage = () => {
        if (loaded == allImages.length) {
          document.querySelector('.slide-loading.slide-ring').style.display = 'none';
        }
      };
      checkImage();
      allImages.forEach((el) => {
        el.addEventListener('load', () => {
          loaded++;
          checkImage();
        });
        el.addEventListener('error', () => {
          loaded++;
          checkImage();
        });
      });
      document
        .querySelector('.Product__Wrapper .slide-wrapper .slide-control')
        .addEventListener('click', (e) => {
          const width = document.querySelector(
            '.Product__Wrapper .fixed-slide-wrapper'
          ).clientWidth;
          const maxWidth = (document.querySelectorAll('.slide-content .bed-bg').length - 1) * width;
          let el = e.target;
          let isNext = false;
          while (el.className != 'btn-control') {
            el = el.parentElement;
          }
          if (el.hasAttribute('data-next')) {
            isNext = true;
          }
          let left = parseInt(document.querySelector('.slide-content').style.left);
          left = isNext
            ? left - width < -maxWidth
              ? 0
              : left - width
            : left + width > 0
              ? -maxWidth
              : left + width;
          document.querySelector('.slide-content').style.left = left + 'px';
        });
      document
        .querySelector('.Product__Wrapper .slide-wrapper .slide-content-mini')
        .addEventListener('click', (e) => {
          let el = e.target;
          let index = el.getAttribute('data-index');
          if (el.tagName == 'BUTTON') {
            this.deleteData(index);
            this.resetSelectedProduct(index);
            this.setDisplayButtonNextStepNameAfterDeleteData();
            this.renderSlide();
          } else {
            this.selectBigAndMiniItem(+index);
          }
        });
      document
        .querySelector('.Product__Wrapper .slide-wrapper .slide-layout-control')
        .addEventListener('click', (e) => {
          let el = e.target;
          if (!el.hasAttribute('data-base-index')) {
            return;
          }
          let index = parseInt(el.getAttribute('data-base-index'));
          this.currentBaseLayout = index;
          this.renderSlide();
        });
      const setupSize = (moreSpace) => {
        const product = document.querySelector('.Product__Wrapper');
        const slide = document.querySelector('.Product__Wrapper .fixed-slide-wrapper');
        const search = document.querySelector('.main-header');
        let slideHeight = slide.clientHeight;
        const top = product.getBoundingClientRect().top;
        const botom = product.getBoundingClientRect().bottom;
        const height = product.clientHeight;
        const announcementBar = document.querySelector('.AnnouncementBar');
        if (!this.originRect) {
          if (window.innerWidth < 1008) {
            this.originRect = {
              top: search.getBoundingClientRect().bottom,
              left: slide.getBoundingClientRect().left,
            };
          } else {
            this.originRect = {
              top: slide.getBoundingClientRect().top,
              left: slide.getBoundingClientRect().left,
            };
          }
        }
        if (window.innerWidth < 1008) {
          slideHeight = slide.querySelector('.slide-wrapper').clientHeight;
          if (slideHeight + this.originRect.top > product.getBoundingClientRect().bottom) {
            slide.style.position = 'absolute';
            slide.style.bottom = 0 + 'px';
            slide.style.top = 'initial';
          } else {
            product.querySelector('.Product__InfoWrapper').style.marginTop =
              slideHeight + this.originRect.top + 'px';
            slide.style.position = 'fixed';
            slide.style.bottom = 'initial';
            slide.style.top =
              this.originRect.top -
              (window.scrollY > 34 ? announcementBar?.clientHeight + moreSpace : 0) +
              'px';
            slide.style.left = this.originRect.left + 'px';
          }
        } else {
          if (slideHeight + document.documentElement.scrollTop > height) {
            slide.style.position = 'relative';
            slide.style.top = height - slideHeight + 'px';
            slide.style.left = 0;
          } else {
            slide.style.position = 'fixed';
            slide.style.top = this.originRect.top + 'px';
            slide.style.left = this.originRect.left + 'px';
          }
        }
      };
      if (!this.originRect && document.documentElement.scrollTop > 0) {
        window.scrollTo({top: 0});
        setTimeout(setupSize, 500);
      }
      if (!this.addedEvent) {
        document.addEventListener('scroll', () => setupSize(2));
        this.addedEvent = true;
      }
      setupSize();
    }

    toggleScroll(condition = false) {
      document.documentElement.style.overflow = condition ? 'hidden' : 'auto';
    }

    editAnItemInBundleSummary(index) {
      document.getElementById('view-bundle-summary-modal').classList.toggle('d-block');
      const cond = document
        .getElementById('view-bundle-summary-modal')
        .classList.contains('d-block');
      this.toggleScroll(cond);
      this.setCurrentBundleStep(this.querySelectorAll('.bed-bundle-item__big-size')[index]);
      this.selectBigAndMiniItem(index);
    }

    addBundleToCart() {
      const {bundleHandle, bundleVariantId, bundleUniqueId, bundleSet} = this?.dataset || {};
      const date = new Date();
      let bundleKey = date.getTime() + '-' + bundleHandle;
      const sortKey = Number(bundleUniqueId);
      const items = [];

      const bedBundleSettingsSentToCart = {
        override_product_tags: this.bedBundleSettings.overrideProductTags,
        raw_extra_discount_percent: this.bedBundleSettings.rawExtraDiscountPercent,
        essential_discount_percent: this.bedBundleSettings.essentialDiscountPercent,
        extra_discount_percent: this.bedBundleSettings.extraDiscountPercent,
        bundle_message: 'BUNDLE OFFER',
      };

      Object.values(this.bedBundleObject).forEach((value) => {
        if (value.bundleItemName === 'extras') {
          if (value.list) {
            value.list.forEach((item) => {
              const id = item?.variant?.id || item?.id;
              if (id) {
                bundleKey += ':' + id;
                items.push({
                  id,
                  quantity: 1,
                  properties: {
                    __bundle: {
                      rule: 'bundle',
                      set: bundleSet,
                      extra: true,
                      __sortKey: sortKey,
                      title: this.dataset.bundleTitle,
                      bedBundleSettings: bedBundleSettingsSentToCart,
                    },
                  },
                });
              }
            });
          }
        } else {
          const id = value?.variant?.id || value?.id;
          if (id) {
            bundleKey += ':' + id;
            items.push({
              id,
              quantity: 1,
              properties: {
                __bundle: {
                  rule: 'bundle',
                  set: bundleSet,
                  __sortKey: sortKey,
                  title: this.dataset.bundleTitle,
                  bedBundleSettings: bedBundleSettingsSentToCart,
                },
              },
            });
          }
        }
      });

      items.forEach((item) => {
        item.properties['__bundle'].key = bundleKey;
      });

      const request = {
        method: 'POST',
        headers: new Headers({'Content-Type': 'application/json'}),
        body: JSON.stringify({items}),
      };

      const setAddToCartBundleTitle = () => {
        this.querySelector('.bundle-summary__add-bundle-to-cart').href = '/cart';
        this.querySelector('.bundle-summary__add-bundle-to-cart').textContent = 'View cart';
      };

      fetch('/cart/add.js', request)
        .then((res) => res.json())
        .then((v) => this.cartDrawer.loadContent(true, setAddToCartBundleTitle))
        .catch((e) => console.log('failed', e));
    }

    setCurrentBundleStep(item) {
      if (item !== undefined) {
        const currentBundleItemId = item.dataset?.bundleItemId;
        const currentBundleItemName = item.dataset?.bundleItemName;
        this.currentBundleItem = {
          currentBundleItemId: parseInt(currentBundleItemId),
          currentBundleItemName,
        };
        if (item.dataset.bundleExtrasIndex) {
          this.currentBundleItem.currentExtrasItemIndex = parseInt(item.dataset.bundleExtrasIndex);
        }
      }
    }

    checkBundleIsNull() {
      let check = true;
      Object.values(this.bedBundleObject).forEach((value) => {
        let list = value?.list || [];
        if (
          value.id !== undefined ||
          Object.values(list).some((item) => Object.keys(item).length)
        ) {
          check = false;
          return;
        }
      });
      return check;
    }

    renderBundleSummary() {
      const modal = document.getElementById('view-bundle-summary-modal');
      const wrapperEssentials = document.querySelector('.bundle-summary-list.list-necessities');
      const wrapperExtras = document.querySelector('.bundle-summary-list.list-extras');

      const isBundleNull = this.checkBundleIsNull();

      if (isBundleNull) {
        modal
          .querySelector('.bundle-summary__add-bundle-to-cart-wrapper')
          .classList.add('disabled');
      } else {
        modal
          .querySelector('.bundle-summary__add-bundle-to-cart-wrapper')
          .classList.remove('disabled');
      }

      const discount = this.checkDiscountValue();
      const getPriceDiscount = (price) => ((100 - discount) * price) / 100;
      let price = 0;

      const elm = ({
        bundle_item_id,
        bundle_item_name,
        id,
        src,
        title,
        price_discount,
        price,
        variant,
        index,
        isExtras,
      }) => `
          <div class="bundle-summary-item" data-index="${index}" data-id="${id}" data-bundle-item-id="${bundle_item_id}" data-bundle-item-name="${bundle_item_name}">
            <div class="bundle-summary-item__image" data-id="${id}">
              <img src=${src}/>
            </div>
            <div class="bundle-summary-item__info-wrapper">
              <h3>${title}</h3>
              <p class="bundle-summary-item__info-variant">${variant?.title}</p>
              <p class="bundle-summary-item__info-price">
                <span class="price-discount">${price_discount === price ? '' : 'AUD $' + (price_discount / 100).toFixed(2)}</span>
                <span class=${price_discount === price ? 'price-no-discount' : 'price'}>AUD $${(price / 100).toFixed(2)}</span>
              </p>
              <div class="bundle-summary-item__info-action">
                <a class="edit" data-toggle-modal>Edit item</a>
                ${isExtras ? '<a class="remove">Remove</a>' : ''}
              </div>
            </div>
          </div>
      `;

      wrapperEssentials.innerHTML = '';
      wrapperExtras.innerHTML = '';

      this.querySelector('.bundle-summary__message').classList.add('d-none');
      this.querySelector('.bundle-summary__button').classList.add('d-none');

      if (!modal.classList.contains('d-block')) {
        this.querySelector('.bundle-summary__message').classList.add('d-none');
        this.querySelector('.bundle-summary__button').classList.add('d-none');
      } else {
        let checkIsMessagedisplayed = Object.values(this.bedBundleObject)
          .filter((item) => item.bundleItemName !== 'extras')
          .every((item) => item.id !== undefined);

        Object.entries(this.bedBundleObject).forEach(([key, value], idx) => {
          if (value.id && value.bundleItemName !== 'extras') {
            price += +value.price;
            const elmRendered = elm({
              bundle_item_id: key,
              bundle_item_name: value.bundleItemName,
              id: value.id,
              title: value.title,
              src: `https:${value.featuredImage}`,
              price_discount: getPriceDiscount(+value.price),
              price: +value.price,
              variant: value.variant,
              index: idx,
              isExtras: false,
            });

            wrapperEssentials.innerHTML += elmRendered;
            if (idx === 2) {
              this.querySelector('.bundle-summary__message').classList.remove('d-none');
              this.querySelector('.bundle-summary__button').classList.remove('d-none');
            }
          }

          if (value?.list?.length && value.bundleItemName === 'extras') {
            let count = 0;
            Object.values(value.list)
              .filter((x) => !!x.id)
              .forEach((p, index) => {
                if (Object.keys(p).length) {
                  price += +p.price;
                  const elmRendered = elm({
                    bundle_item_name: value.bundleItemName,
                    bundle_item_id: key,
                    id: p.id,
                    title: p.title,
                    src: `https:${p.featuredImage}`,
                    price_discount: getPriceDiscount(+p.price),
                    price: +p.price,
                    variant: p.variant,
                    index: index,
                    isExtras: true,
                  });

                  wrapperExtras.innerHTML += elmRendered;
                  count = index + 1;
                }
              });

            this.querySelector('.bundle-summary__message').classList.add('d-none');
            if (count === 0 && checkIsMessagedisplayed) {
              this.querySelector('.bundle-summary__message').classList.remove('d-none');
            }
            if (count === this.EXTRA_BUNDLE_ITEMS) {
              this.querySelector('.bundle-summary__button').classList.add('d-none');
            }

            if (count > 0) {
              this.querySelector('.bundle-summary__extras-title').classList.add('active');
            } else {
              this.querySelector('.bundle-summary__extras-title').classList.remove('active');
            }
          }
        });
      }

      this.querySelector('.bundle-summary__discount-title').innerHTML = `${discount}%`;
      this.querySelector('.bundle-summary__nescessities-title-discount').innerHTML = `${discount}%`;
      this.querySelector('.bundle-summary__subtotal-price').innerHTML =
        `AUD $${(getPriceDiscount(price) / 100).toFixed(2)}`;
      this.querySelector('.bundle-summary__saving-price').innerHTML =
        `AUD $${((price - getPriceDiscount(price)) / 100).toFixed(2)}`;
    }

    initOptions() {
      this.querySelectorAll('.bed-bundle-options').forEach((item) => {
        item.querySelectorAll('.gpo-swatches:not(.image-swatches)').forEach((innerItem) => {
          this.renderOptionsExceptImageSwatches(innerItem);
        });

        item.querySelectorAll('.gpo-swatches.image-swatches').forEach((innerItem) => {
          this.renderImageSwatches(innerItem);
        });
      });

      const currentBundleItemName = this.currentBundleItem.currentBundleItemName;
      this.querySelectorAll(`.bed-bundle-options.${currentBundleItemName}`).forEach((item) => {
        item.style.display = 'block';
      });
    }

    chooseSizeOrTypeOptions(item, type = 'size') {
      const name = this.currentBundleItem.currentBundleItemName;
      const colorOption = this.querySelector(
        `.bed-bundle-options__fabric-color .gpo-selected-values`
      )?.innerText?.split('--')?.[0];
      if (colorOption) {
        const value = item.value.split('--')[0];
        const newName =
          name !== 'extras'
            ? name
            : this.querySelector(
                `.bed-bundle-options.${name} .gpo-selected-values`
              )?.innerText?.split('--')?.[0];
        let option;
        let anotherOption;

        if (type === 'size') {
          option = value;
          anotherOption = this.querySelector(
            `.bed-bundle-options.${newName}-type .gpo-selected-values.has-value`
          )?.innerText?.split('--')?.[0];
        }

        if (type === 'type') {
          anotherOption = value;
          option = this.querySelector(
            `.bed-bundle-options.${newName}-size .gpo-selected-values`
          )?.innerText?.split('--')?.[0];
        }
        const handle = `${colorOption}-${newName === 'sheet' ? anotherOption : newName}`;
        this.onFetchData(handle, option);
      }
    }
    updateChoose(item) {
      if (this.currentBundleItem.currentBundleItemName == 'extras') {
        this.bedBundleObject[this.currentBundleItem.currentBundleItemId].list[
          this.currentBundleItem.currentExtrasItemIndex
        ].history = {
          ...this.bedBundleObject[this.currentBundleItem.currentBundleItemId].list[
            this.currentBundleItem.currentExtrasItemIndex
          ].history,
          ...item,
        };
      } else {
        this.bedBundleObject[this.currentBundleItem.currentBundleItemId].history = {
          ...this.bedBundleObject[this.currentBundleItem.currentBundleItemId].history,
          ...item,
        };
      }
    }
    removeChoose(item) {
      if (this.currentBundleItem.currentBundleItemName == 'extras') {
        ['id', 'featuredImage', 'images', 'tags', 'title', 'variant', 'handle'].forEach((x) => {
          delete this.bedBundleObject[this.currentBundleItem.currentBundleItemId].list[
            this.currentBundleItem.currentExtrasItemIndex
          ][x];
        });
        delete this.bedBundleObject[this.currentBundleItem.currentBundleItemId].list[
          this.currentBundleItem.currentExtrasItemIndex
        ].history[item];
      } else {
        ['id', 'featuredImage', 'images', 'tags', 'title', 'variant', 'handle'].forEach((x) => {
          delete this.bedBundleObject[this.currentBundleItem.currentBundleItemId][x];
        });
        delete this.bedBundleObject[this.currentBundleItem.currentBundleItemId].history[item];
      }
      this.checkDisabledViewBundleSummary();
      this.renderSlide();
    }
    chooseColorOptions(item) {
      const value = item.value.split('--')[0];
      const name = this.currentBundleItem.currentBundleItemName;
      const newName =
        name !== 'extras'
          ? name
          : this.querySelector(
              `.bed-bundle-options.${name} .gpo-selected-values.has-value`
            )?.innerText?.split('--')?.[0];
      const option = this.querySelector(
        `.bed-bundle-options.${newName}-size .gpo-selected-values.has-value`
      )?.innerText?.split('--')?.[0];
      const anotherOption = this.querySelector(
        `.bed-bundle-options.${newName}-type .gpo-selected-values.has-value`
      )?.innerText?.split('--')?.[0];
      const handle = `${value}-${newName === 'sheet' ? anotherOption : newName}`;
      this.onFetchData(handle, option);
    }

    renderOptionsExceptImageSwatches(item) {
      const value = item.querySelector('input').value;
      const title = value.split('--')[1];
      item.querySelector('label span').innerHTML = title;
      item.querySelector('.gpo-tooltip .gpo-tooltip__title span').innerHTML = title;
    }

    renderImageSwatches(item) {
      const value = item.querySelector('input').value;
      const title = value.split('--')[1];
      item.querySelector('.gpo-tooltip .gpo-tooltip__title span').innerHTML = title;
      if (value.includes('hidden')) {
        item.className = '';
        item.classList.add('fabric-color-custom');
        item.style = null;
        item.innerHTML = `<label class="fabric-color-custom-label"><span class="fabric-color-custom-title">${title}</span></label>`;
      }
    }

    onDisplayOptions(extrasBundleItemName) {
      let selector = extrasBundleItemName
        ? '.bed-bundle-options:not(.extras):not(.custom-bed)'
        : '.bed-bundle-options:not(.custom-bed)';
      const currentBundleItemName = this.currentBundleItem.currentBundleItemName;
      let history;
      if (currentBundleItemName == 'extras') {
        if (!extrasBundleItemName) {
          history =
            this.bedBundleObject[this.currentBundleItem.currentBundleItemId].list[
              this.currentBundleItem.currentExtrasItemIndex
            ].history;
        } else {
          this.bedBundleObject[this.currentBundleItem.currentBundleItemId].list[
            this.currentBundleItem.currentExtrasItemIndex
          ].history = null;
        }
      } else {
        history = this.bedBundleObject[this.currentBundleItem.currentBundleItemId].history;
      }
      this.querySelectorAll(selector).forEach((item) => {
        item.style.display = 'none';
        if (
          item.classList.contains(
            extrasBundleItemName ? extrasBundleItemName : currentBundleItemName
          )
        ) {
          item.style.display = 'block';
          if (!history) {
            document
              .querySelectorAll(
                `[data-element-id=${item.getAttribute('data-element-id')}] input:checked`
              )
              .forEach((x) => {
                let input = document.querySelector(
                  `input[data-field-name="${x.getAttribute('name')}"]`
                );
                if (input) {
                  input.value = null;
                  input.removeAttribute('name');
                }
                x.checked = false;
                x.setAttribute('previous-value', 'false');
              });
          }
        }
      });
      let oldExtrasBundleItemName;
      if (currentBundleItemName == 'extras' && history) {
        oldExtrasBundleItemName = history.value.split('--')[0];
      }
      if (oldExtrasBundleItemName) {
        this.querySelectorAll(`.${oldExtrasBundleItemName}${selector}`).forEach((item) => {
          item.style.display = 'block';
        });
      }
      if (history) {
        ['extra', 'type', 'size', 'color'].forEach((x) => {
          if (history[x]) {
            if (!document.querySelector('#' + history[x]).checked) {
              document.querySelector('#' + history[x]).click();
            }
            document.querySelector('#' + history[x]).checked = true;
          }
        });
      }
    }

    selectABedbundleItem(selector = '', index = 0) {
      const selectedItem = this.querySelectorAll(selector)[index];
      const activeItem = this.querySelector(`${selector}.active`);
      activeItem?.classList?.remove('active');
      selectedItem?.classList?.add('active');
    }

    selectMiniIconBundleItem(selector = '', index = 0) {
      const currentTarget = this.querySelectorAll(selector)[index];
      const image = currentTarget?.querySelector('img');
      if (image) {
        image.src = JSON.parse(image.dataset.src)?.selected_src;

        [...this.querySelectorAll(selector)]
          .filter((_, idx) => idx !== index)
          .forEach((elm) => {
            const image = elm.querySelector('img');
            image.src = JSON.parse(image.dataset.src)?.original_src;
          });
      }
    }

    selectBigAndMiniItem(index, isClickedManually) {
      this.selectABedbundleItem('.bed-bundle-item__big-size', index);
      const list = Object.values(this.bedBundleObject).find(
        (item) => item.bundleItemName === 'extras'
      )?.list;
      const check = list.every((item) => item.id != undefined);
      if (index === this.MAX_BUNDLE_ITEMS - 1 && check) {
        this.setCurrentBundleStep(this.querySelectorAll('.bed-bundle-item__big-size')[index]);
        this.querySelector('.next-step__wrapper').classList.remove('active');
        this.querySelector('.next-step__wrapper').classList.add('disabled');
        this.querySelector('.next-step').classList.add('d-none');
        this.querySelector('.next-step--last').classList.remove('d-none');
        this.onDisplayOptions();
        return;
      }

      if (index <= this.ESSENTIAL_BUNDLE_ITEMS) {
        this.selectMiniIconBundleItem('.bed-bundle-mini-icon', index);
      }

      if (index < this.ESSENTIAL_BUNDLE_ITEMS) {
        if (Object.values(this.bedBundleObject)[index].id === undefined) {
          this.querySelector('.next-step__wrapper').classList.remove('active');
        } else {
          this.querySelector('.next-step__wrapper').classList.add('active');
        }
      } else {
        const list = Object.values(this.bedBundleObject).find(
          (item) => item.bundleItemName === 'extras'
        )?.list;
        if (list[index - 3]?.id === undefined) {
          this.querySelector('.next-step__wrapper').classList.remove('active');
        } else {
          this.querySelector('.next-step__wrapper').classList.add('active');
        }
      }

      this.setCurrentBundleStep(this.querySelectorAll('.bed-bundle-item__big-size')[index]);
      this.setDisplayButtonNextStepName();
      this.onDisplayOptions();
      let y = 0;
      window.scrollTo({top: y, behavior: 'smooth'});
    }

    checkCurrentDisplayedBundleItems() {
      let number = 0;
      this.querySelectorAll('.bed-bundle-item__big-size').forEach((item = new HTMLElement()) => {
        if (!item.classList.contains('d-none')) number++;
      });
      return Math.min(number, this.MAX_BUNDLE_ITEMS);
    }

    setDisplayButtonNextStepName = (isFetched = false) => {
      let checkAreAllItemsSelected = false;
      document.querySelector('.next-step--last').classList.add('d-none');
      document.querySelector('.next-step').classList.remove('d-none');

      const currentBigBundleItemActive = this.querySelector('.bed-bundle-item__big-size.active');
      const {index, bundleExtrasIndex} = currentBigBundleItemActive?.dataset;
      let idx = index ? parseInt(index) : 0;
      let currentItem = this.bedBundleObject[this.currentBundleItem.currentBundleItemId];
      let name,
        preName = '';
      const rawExtraDiscountPercent = this.bedBundleSettings?.rawExtraDiscountPercent || 20;
      if (bundleExtrasIndex) {
        currentItem = currentItem.list[+bundleExtrasIndex];
        let i = +bundleExtrasIndex + 3;
        let diff = this.MAX_BUNDLE_ITEMS - 1 - i;
        name = `Up To ${diff} extras for ${rawExtraDiscountPercent}% off`;
        if (diff === 0 && isFetched) {
          checkAreAllItemsSelected = true;
        }
        if (diff == 3) {
          name = `Add Sheet then Up To ${diff} Extras for ${rawExtraDiscountPercent}% off`;
        } else if (diff == 1) {
          diff = 'final';
          name = `Add ${diff} item to bundle`;
        } else if (diff == 0) {
          preName = 'Maximum extra products added';
          name = '';
        } else {
          name = '';
          preName = 'ADD TO BUNDLE';
        }
        if (!currentItem.id) {
          preName = 'ADD TO BUNDLE';
          name = '';
        }
      } else {
        if (!currentItem.id) {
          let bundleName =
            this.bundleName[currentItem.bundleItemName] || currentItem.bundleItemName;
          preName = `Add ${bundleName} to Bundle`;
          name = '';
        } else {
          idx++;
          name = Object.values(this.bedBundleObject).find((_, i) => i === idx)?.bundleItemName;
          if (idx < 3) {
            preName = 'Next Step add';
          }
          if (name === 'extras') {
            let number = this.MAX_BUNDLE_ITEMS - idx;
            name = `up to ${number} extras for ${rawExtraDiscountPercent}% off`;
            if (number == 3) {
              name = `Add Sheet then Up To 3 Extras for ${rawExtraDiscountPercent}% off`;
            } else if (number == 1) {
              name = `up to ${number} extra for ${rawExtraDiscountPercent}% off`;
            } else if (number == 0) {
              name = 'Maximum extra products added';
            }
          }
        }
      }

      this.querySelector('.next-step-pre-title').innerHTML = preName;
      this.querySelector('.next-step-title').innerHTML = name;

      if (checkAreAllItemsSelected) {
        document.querySelector('.next-step__wrapper').classList.add('disabled');
        document.querySelector('.next-step').classList.add('d-none');
        document.querySelector('.next-step--last').classList.remove('d-none');
      } else {
        document.querySelector('.next-step__wrapper').classList.remove('disabled');
      }
    };

    setDisplayButtonNextStepNameAfterDeleteData = () => {
      let checkAreAllItemsSelected = false;
      checkAreAllItemsSelected =
        Object.values(this.bedBundleObject)
          .filter((item) => item.bundleItemName !== 'extras')
          .every((item) => item.id !== undefined) &&
        Object.values(this.bedBundleObject)
          .find((item) => item.bundleItemName === 'extras')
          ?.list?.every((item) => item.id !== undefined);

      document.querySelector('.next-step--last').classList.add('d-none');
      document.querySelector('.next-step').classList.remove('d-none');
      let index;
      let bundleItemName;

      let tempIndex = Object.values(this.bedBundleObject)
        .filter((item) => item.bundleItemName !== 'extras')
        .findIndex((item) => item.id === undefined);

      if (tempIndex > -1) {
        index = tempIndex;
        bundleItemName = Object.values(this.bedBundleObject).filter(
          (item) => item.bundleItemName !== 'extras'
        )[index].bundleItemName;
      } else {
        tempIndex = Object.values(this.bedBundleObject)
          .filter((item) => item.bundleItemName === 'extras')[0]
          .list.findIndex((item) => item.id === undefined);
        bundleItemName = 'extras';

        if (tempIndex > -1) {
          index = tempIndex === 0 ? 0 : tempIndex - 1;
        } else {
          tempIndex = this.MAX_BUNDLE_ITEMS - 1;
          index = this.MAX_BUNDLE_ITEMS - 1;
        }
      }

      if (bundleItemName === undefined) return;

      if (bundleItemName !== 'extras') {
        let idx = index + 1;
        let name = Object.values(this.bedBundleObject).find((item, i) => i === idx).bundleItemName;

        this.querySelector('.next-step-pre-title').innerHTML =
          idx !== this.ESSENTIAL_BUNDLE_ITEMS
            ? this.querySelector('.next-step-pre-title').innerHTML
            : 'Optional Add';

        this.querySelector('.next-step-title').innerHTML =
          idx !== this.ESSENTIAL_BUNDLE_ITEMS
            ? name
            : this.MAX_BUNDLE_ITEMS - idx == 1
              ? 'Final extra'
              : `up to ${this.MAX_BUNDLE_ITEMS - idx} extras`;
      } else {
        let idx = index + 3;
        if (idx < this.MAX_BUNDLE_ITEMS - 1) {
          this.querySelector('.next-step-pre-title').innerHTML = 'Optional Add';
          let number = this.MAX_BUNDLE_ITEMS - 1 - idx;
          this.querySelector('.next-step-title').innerHTML = `up to ${number} extras`;
          if (number == 1) {
            this.querySelector('.next-step-title').innerHTML = `Final extra`;
          }
        }
      }

      if (checkAreAllItemsSelected) {
        document.querySelector('.next-step').classList.add('d-none');
        document.querySelector('.next-step--last').classList.remove('d-none');
      }
    };

    jumpToNextBundleItem() {
      let index = 0;
      const currentDisplayedBundleItems = this.checkCurrentDisplayedBundleItems();

      let {currentBundleItemId, currentBundleItemName, currentExtrasItemIndex} =
        this.currentBundleItem;

      if (currentBundleItemName !== 'extras') {
        index = Object.keys(this.bedBundleObject).findIndex(
          (item) => +item === +currentBundleItemId
        );
        if (index == 0) {
          index = 0;
          const checkmark = document.querySelector(
            '.bed-bundle-mini-icon-custom .bed-bundle-mini-icon__checkmark'
          );
          if (checkmark.style.display != 'block') {
            return;
          } else if (this.bedBundleObject[currentBundleItemId].hasOwnProperty('id')) {
            index = 1;
          }
        } else {
          if (!this.bedBundleObject[currentBundleItemId].hasOwnProperty('id')) {
            return;
          }
          index = index > -1 ? index + 1 : 0;
        }

        const newCurrentBundleItemId = this.querySelectorAll('.bed-bundle-item__big-size')[index]
          ?.dataset?.bundleItemId;
        if (parseInt(newCurrentBundleItemId) === currentBundleItemId) {
          this.querySelectorAll('.bed-bundle-item__big-size')[index].classList.remove('d-none');
        }
      } else {
        const list = this.bedBundleObject[currentBundleItemId].list;
        let indexAtEmptyObj = list.findIndex((item) => item.id === undefined);
        if (currentExtrasItemIndex + 3 < currentDisplayedBundleItems) {
          index = currentExtrasItemIndex + 4;
        } else if (indexAtEmptyObj > -1) {
          index = indexAtEmptyObj + 3;
          this.querySelectorAll('.bed-bundle-item__big-size')[index].classList.remove('d-none');
        } else {
          index = +currentExtrasItemIndex + 4;
        }
      }
      this.setCurrentBundleStep(this.querySelectorAll('.bed-bundle-item__big-size')[index]);
      this.selectBigAndMiniItem(index);
      document.querySelector('.bed-bundle-mini-icon-custom.active')?.classList.remove('active');
    }

    changeStateNextStepButton() {
      let checkAreAllItemsSelected = false;
      checkAreAllItemsSelected =
        Object.values(this.bedBundleObject)
          .filter((item) => item.bundleItemName !== 'extras')
          .every((item) => item.id !== undefined) &&
        Object.values(this.bedBundleObject)
          .find((item) => item.bundleItemName === 'extras')
          ?.list?.every((item) => item.id !== undefined);

      if (checkAreAllItemsSelected) return;

      let {currentBundleItemId, currentBundleItemName, currentExtrasItemIndex} =
        this.currentBundleItem;
      if (currentBundleItemName === 'extras' && currentExtrasItemIndex === 4) {
        this.querySelector('.next-step__wrapper').classList.add('disabled');
        this.querySelector('.next-step:not(.next-step--last)').classList.add('d-none');
        this.querySelector('.next-step--last').classList.remove('d-none');
      } else {
        this.querySelector('.next-step__wrapper').classList.add('active');
        this.querySelector('.next-step__wrapper').classList.remove('disabled');
      }
    }

    resetSelectedProduct(index) {
      let newIndex = index;
      this.setCurrentBundleStep(this.querySelectorAll('.bed-bundle-item__big-size')[newIndex]);
      const bigSizeItem = this.querySelectorAll('.bed-bundle-item__big-size')[newIndex];
      const src = bigSizeItem?.dataset?.src;
      const image = bigSizeItem?.querySelector('img');

      if (image) {
        image.style.padding = 0;
        image.src = src;
      }

      bigSizeItem?.querySelector('.select-bundle-item-title-init')?.classList?.remove('d-none');

      if (newIndex < this.ESSENTIAL_BUNDLE_ITEMS) {
        bigSizeItem
          .querySelector('.select-bundle-item-title:not(.remove-bundle-item-title)')
          .classList.add('d-none');
        this.removeCheckmarkDone('.bed-bundle-mini-icon', newIndex);
      }

      if (newIndex === this.ESSENTIAL_BUNDLE_ITEMS) {
        bigSizeItem.querySelector('.remove-bundle-item-title').classList.add('d-none');
        this.removeCheckmarkDone('.bed-bundle-mini-icon', newIndex);
      }

      if (newIndex >= this.ESSENTIAL_BUNDLE_ITEMS) {
        let {currentBundleItemId} = this.currentBundleItem;
        let list = this.bedBundleObject[currentBundleItemId].list;

        this.querySelectorAll('.bed-bundle-item__big-size').forEach((item, idx) => {
          if (![0, 1, 2].includes(idx)) {
            let src = item.dataset.src;
            item.querySelector('img').src = src;
            item.classList.add('d-none');
            item.querySelector('.select-bundle-item-title-init').classList.remove('d-none');
            item.querySelector('.remove-bundle-item-title').classList.add('d-none');
          }
        });

        list.forEach((item, idx) => {
          if (Object.keys(item).length) {
            const elm = this.querySelectorAll('.bed-bundle-item__big-size')[idx + 3];
            elm.classList.remove('d-none');
            let src = item.featuredImage;
            elm.querySelector('img').src = src;
            elm.querySelector('.select-bundle-item-title-init').classList.add('d-none');
            elm.querySelector('.remove-bundle-item-title').classList.remove('d-none');
          }
        });

        let checkIsAllEmptyObj = list.every((item) => !Object.keys(item).length);

        if (checkIsAllEmptyObj) {
          const elm = this.querySelectorAll('.bed-bundle-item__big-size')[3];
          elm.classList.remove('d-none');
          elm.querySelector('.select-bundle-item-title-init').classList.remove('d-none');
        }

        if (newIndex === this.ESSENTIAL_BUNDLE_ITEMS + 1) {
          this.selectBigAndMiniItem(newIndex - 1);
        }
      }
    }

    onFetchData(handle, sizeSelected) {
      const loadingEl = document.querySelector('.slide-loading');
      loadingEl.style.display = 'initial';
      const bigSizeItemActive = this.querySelector('.bed-bundle-item__big-size.active');
      const image = bigSizeItemActive.querySelector('img');
      image.classList.add('Image--lazyLoading');
      const alertModal = document.getElementById('alert-bundle-status');
      Promise.all([
        fetch(window.location.origin + '/api/2023-04/graphql.json', {
          method: 'POST',
          headers: {
            mode: 'cors',
            'content-type': 'application/graphql',
            'x-shopify-storefront-access-token': 'c35687a7a002924b25370581272edc48',
          },
          body: `{ product(handle: \"${handle}\") { kidExtraImagesURL: metafield(namespace: \"custom\", key: \"kid_extras_url\") { value } kidExtraImages: metafield(namespace: \"custom\", key: \"kid_extras\") { references (first: 10) { nodes { ... on MediaImage { image { url } } } } } adult1ExtraImagesURL: metafield(namespace: \"custom\", key: \"adult_1_extras_url\") { value } adult1ExtraImages: metafield(namespace: \"custom\", key: \"adult_1_extras\") { references (first: 10) { nodes { ... on MediaImage { image { url } } } } } adult2ExtraImages: metafield(namespace: \"custom\", key: \"adult_2_extras\") { references (first: 10) { nodes { ... on MediaImage { image { url } } } } } adultImagesURL: metafield(namespace: \"custom\", key: \"3d_images_url\") { value } adultImages: metafield(namespace: \"custom\", key: \"3d_images\") { references (first: 10) { nodes { ... on MediaImage { image { url } } } } } adult2Images: metafield(namespace: \"custom\", key: \"3d_images_2\") { references (first: 10) { nodes { ... on MediaImage { image { url } } } } } childImagesURL: metafield(namespace: \"custom\", key: \"3d_child_images_url\") { value } childImages: metafield(namespace: \"custom\", key: \"3d_child_images\") { references (first: 10) { nodes { ... on MediaImage { image { url } } } } } } }`,
        })
          .then((res) => res.json())
          .then((item) => {
            try {
              let images =
                item.data.product.adultImages?.references?.nodes?.map((x) => x.image.url) || [];
              let imagesURL = JSON.parse(item.data.product.adultImagesURL?.value || null);
              let extraImages =
                item.data.product.adult1ExtraImages?.references?.nodes?.map((x) => x.image.url) ||
                [];
              let extraImagesURL = JSON.parse(
                item.data.product.adult1ExtraImagesURL?.value || null
              );
              let images2 =
                item.data.product.adult2Images?.references?.nodes?.map((x) => x.image.url) || [];
              let extraImages2 =
                item.data.product.adult2ExtraImages?.references?.nodes?.map((x) => x.image.url) ||
                [];
              let childImages =
                item.data.product.childImages?.references?.nodes?.map((x) => x.image.url) || [];
              let childImagesURL = JSON.parse(item.data.product.childImagesURL?.value || null);
              let childExtraImages =
                item.data.product.kidExtraImages?.references?.nodes?.map((x) => x.image.url) || [];
              let childExtraImagesURL = JSON.parse(
                item.data.product.kidExtraImagesURL?.value || null
              );

              return {
                'adult-1': imagesURL || images,
                'adult-2': images2,
                kid: childImagesURL || childImages,
                'adult-1-extra': extraImagesURL || extraImages,
                'adult-2-extra': extraImages2,
                'kid-extra': childExtraImagesURL || childExtraImages,
              };
            } catch (error) {
              console.log('Fetch product metadata Error', error);
            }
          }),
        fetch(`/products/${handle}.js`).then((res) => res.json()),
      ])
        .then(([images, product]) => {
          const productCheck = product.tags.find((item) => item.includes('discount'));
          if (!productCheck) {
            image.classList.remove('Image--lazyLoading');
            alertModal.click();
            return;
          }

          const variant = product.variants
            .filter(
              (v) => v.title.toLowerCase().split(' ').join('-') === sizeSelected && v.available
            )
            .map((v) => ({id: v.id, title: v.title, price: v.price}))?.[0];

          if (!variant) {
            image.classList.remove('Image--lazyLoading');
            alertModal.click();
            return;
          }

          let product_type = this.currentBundleItem.currentBundleItemName;
          if (product_type == 'extras') {
            let extra_type = document.querySelector('[name="properties[extras-item-selection]"]');
            if (!extra_type) {
              extra_type = document.querySelector('[name="properties[buttons-11]"]');
            }
            if (extra_type) {
              product_type = extra_type.value.split('--')[0];
            }
          }
          if (product_type == 'sheet') {
            let sheet_type = document.querySelector(
              '[name="properties[sheet-type-variants-selection]"]'
            );
            if (!sheet_type) {
              sheet_type = document.querySelector('[name="properties[buttons-13]"]');
            }
            product_type = sheet_type.value.split('--')[0];
          }

          const newProduct = {
            id: product.id,
            handle: product.handle,
            featuredImage: product.featured_image,
            featuredImageRatio: product.media.find((item) =>
              item.src.includes(product.featured_image)
            )?.aspect_ratio,
            tags: product.tags,
            price: variant.price,
            title: product.title,
            productType: product_type,
            variant,
            images,
          };

          this.updateData(newProduct);
          this.setDisplayButtonNextStepName(true);

          const elm = this.querySelector('.bed-bundle-item__big-size.active');
          let index = elm?.dataset?.index;
          const currentBundleItemName = this.currentBundleItem.currentBundleItemName;
          if (index > -1) {
            if (currentBundleItemName === 'extras') {
              index = parseInt(index) + 3;
            }
            this.markDoneCheckmark(
              '.bed-bundle-mini-icon',
              Math.min(index, this.ESSENTIAL_BUNDLE_ITEMS)
            );
          }
          this.displaySelectedProduct({
            featuredImage: newProduct.featuredImage,
            featuredImageRatio: newProduct.featuredImageRatio,
            index,
          });
          this.renderSlide();
          this.changeStateNextStepButton(index);
          image.classList.remove('Image--lazyLoading');
          document
            .querySelector(`.bed-bundle-mini-icon:nth-child(n + ${3 + +index})`)
            ?.classList.add('enable');
        })
        .catch((e) => {
          image.classList.remove('Image--lazyLoading');
          alertModal.click();
        });
    }

    updateData(item) {
      let {currentBundleItemId, currentBundleItemName, currentExtrasItemIndex} =
        this.currentBundleItem;
      //update essential bundle items
      if (currentBundleItemName !== 'extras') {
        let newObj = this.bedBundleObject[currentBundleItemId] || {};
        newObj = {...newObj, ...item};
        this.bedBundleObject[currentBundleItemId] = newObj;
        this.checkDisabledViewBundleSummary();
        return;
      }

      //update essential bundle extras items
      let newObj = this.bedBundleObject[currentBundleItemId] || {};
      let list = newObj.list ? newObj.list : [];
      let index = list.findIndex((_, idx) => idx === currentExtrasItemIndex);
      if (index > -1) {
        let itemAtIndex = list[index];
        list[index] = {...itemAtIndex, ...item};
      }
      this.bedBundleObject[currentBundleItemId].list = list;
    }

    deleteData(idx) {
      this.setCurrentBundleStep(this.querySelectorAll('.bed-bundle-item__big-size')[idx]);
      let {currentBundleItemId, currentBundleItemName, currentExtrasItemIndex} =
        this.currentBundleItem;

      //delete essential bundle items
      if (currentBundleItemName !== 'extras') {
        return;
      }

      //delete essential bundle extras items
      let newObj = this.bedBundleObject[currentBundleItemId] || {};
      let list = newObj.list ? newObj.list : [];
      let newList = list.filter((_, idx) => idx !== currentExtrasItemIndex);
      for (let i = newList.length; i < this.ESSENTIAL_BUNDLE_ITEMS; i++) {
        newList.push({});
      }
      let newIndex = newList.findIndex((item) => !Object.keys(item).length);
      newIndex = newIndex === 0 ? 0 : newIndex - 1;
      this.bedBundleObject[currentBundleItemId].list = newList;
      this.setCurrentBundleStep(this.querySelectorAll('.bed-bundle-item__big-size')[newIndex]);
      this.changeStateNextStepButton(newIndex + 3 - 1);
      const newIdx = newIndex + 3;
      if (newIdx >= this.ESSENTIAL_BUNDLE_ITEMS) {
        this.selectBigAndMiniItem(newIdx); //+3 because it's extra item
      }
    }

    markDoneCheckmark(selector = '', index = 0) {
      const currentTarget = this.querySelectorAll(selector)[index];
      const checkmark = currentTarget.querySelector('.bed-bundle-mini-icon__checkmark');
      checkmark.style.display = 'block';
    }

    removeCheckmarkDone(selector = '', index = 0) {
      const currentTarget = this.querySelectorAll(selector)[index];
      const checkmark = currentTarget.querySelector('.bed-bundle-mini-icon__checkmark');
      checkmark.style.display = 'none';
    }

    calculateImagePadding(img, imageUrlRatio) {
      const diff = Math.abs(img.width - img.height);
      if (imageUrlRatio >= 0.99 && imageUrlRatio <= 1.01) {
        img.style.padding = `${diff / 2}px 2px`;
        return;
      }
      img.style.padding = '2px';
    }

    displaySelectedProduct(item = {}) {
      const index = item?.index;
      const bigSizeItem = this.querySelector('.bed-bundle-item__big-size.active');
      const img = bigSizeItem.querySelector('img');
      img.style.padding = 0;
      img.src = item?.featuredImage;
      this.calculateImagePadding(img, item?.featuredImageRatio);

      bigSizeItem.querySelector('.select-bundle-item-title-init').classList.add('d-none');
      if (index < this.ESSENTIAL_BUNDLE_ITEMS) {
        bigSizeItem.querySelector('.select-bundle-item-title').classList.remove('d-none');
      } else {
        bigSizeItem?.querySelector('.remove-bundle-item-title')?.classList?.remove('d-none');
      }
      return () => clearTimeout(fn);
    }

    checkDiscountValue() {
      let discount = 0;
      let extraDiscountPercent = this.bedBundleSettings?.extraDiscountPercent || 5;
      Object.values(this.bedBundleObject).forEach((value) => {
        if (value.bundleItemName !== 'extras') {
          discount = value.discount;
          if (value.id === undefined) {
            discount = 0;
            return;
          }
        }

        if (discount !== 0) {
          if (value?.list?.some((item) => !!item.id)) {
            discount = value.discount + extraDiscountPercent;
          }
        }
      });
      return discount;
    }

    checkDisabledViewBundleSummary() {
      let check = Object.values(this.bedBundleObject)
        .filter((item) => item.bundleItemName !== 'extras')
        .every((item) => item.id !== undefined);

      const triggerOpenBundlePopup = this.querySelector('.view-bundle-summary__wrapper');
      if (check) {
        triggerOpenBundlePopup.classList.remove('disabled');
        triggerOpenBundlePopup.setAttribute('data-toggle-modal', '');
        triggerOpenBundlePopup.setAttribute('data-modal-id', 'view-bundle-summary-modal');
        //onClick view bundle summary popup
        this.querySelector('.view-bundle-summary__wrapper').addEventListener('click', (e) => {
          e.stopPropagation();
          this.renderBundleSummary.bind(this)();
          this.querySelectorAll('.bundle-summary-item').forEach((item, idx) => {
            item
              .querySelector('.bundle-summary-item__info-action .edit')
              .addEventListener('click', () => {
                document.getElementById('view-bundle-summary-modal').classList.toggle('d-block');
                const cond = document
                  .getElementById('view-bundle-summary-modal')
                  .classList.contains('d-block');
                this.toggleScroll(cond);
                this.selectBigAndMiniItem(idx);
              });
          });
        });
      } else {
        this.querySelector('.view-bundle-summary__wrapper').classList.add('disabled');
        triggerOpenBundlePopup.removeAttribute('data-toggle-modal');
        triggerOpenBundlePopup.removeAttribute('data-modal-id');
      }
    }
  }

  customElements.define('bed-bundle', BedBundle);
}
